export default "__VITE_ASSET__B3Kf1ye9__"